import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Api } from './api';
import { Layout } from '../models/layout.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private endpoint = '/layouts';

  constructor(private api: Api) {}

  getLayouts(
    page: number = 0,
    size: number = 20,
    sort: string = 'id,asc'
  ): Observable<Layout[]> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      sort: sort,
    };
    return this.api.get(this.endpoint, params);
  }

  getLayoutById(id: number): Observable<Layout> {
    return this.api.get(`${this.endpoint}/${id}`);
  }

  createLayout(layout: Partial<Layout>): Observable<Layout> {
    return this.api.post(this.endpoint, layout);
  }

  updateLayout(id: number, layout: Partial<Layout>): Observable<Layout> {
    return this.api.putGenerate(`${this.endpoint}/${id}`, layout);
  }

  deleteLayout(id: number): Observable<void> {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  getAllLayouts(): Observable<Layout[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<Layout[]>(this.endpoint, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<Layout[]>) => response.body || [])
    );
  }

  getLayoutsByQueryId(queryId: number): Observable<Layout[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<Layout[]>(`${this.endpoint}?queryId.equals=${queryId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<Layout[]>) => response.body || [])
    );
  }

  getLayoutsByDataSourceId(datasourceId: number): Observable<Layout[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<Layout[]>(`${this.endpoint}?datasourceId.equals=${datasourceId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<Layout[]>) => response.body || [])
    );
  }

  getLayoutsByDataStoreId(dataStoreId: number): Observable<Layout[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<Layout[]>(`${this.endpoint}?dataStoreId.equals=${dataStoreId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<Layout[]>) => response.body || [])
    );
  }

  getLayoutsByTableId(tableId: number): Observable<Layout[]> {
    const params = {
      page: '0',
      size: '500',
      sort: 'id,asc'
    };
    return this.api.getGenerate<Layout[]>(`${this.endpoint}?tableId.equals=${tableId}`, { params, observe: 'response' }).pipe(
      map((response: HttpResponse<Layout[]>) => response.body || [])
    );
  }

  countLayouts(): Observable<number> {
    return this.api.get(`${this.endpoint}/count`);
  }
} 